<template>
  <div id="app" class="app-shell">
    <!-- Include the header on every page -->
    <SiteHeader />
    
    <!-- Router view will display the Home or Registration component -->
    <router-view />
  </div>
</template>

<script>
import SiteHeader from './components/HeaderComponent.vue'; // Import the header

export default {
  name: "App",
  components: {
    SiteHeader, // Register the header component
  },
};
</script>

<style>
</style>
